import React from 'react';
import { PercentLabel } from '../Labels';
import { Tooltip } from '../../Tooltip';
import { Tag, Label, Value } from './partials';
export var InfoLabel = function InfoLabel(_ref) {
  var value = _ref.value,
    unit = _ref.unit,
    label = _ref.label,
    tooltip = _ref.tooltip;
  var trend = typeof value === 'number' ? value >= 0 ? 'bull' : 'bear' : null;
  return React.createElement(Tag, {
    trend: trend
  }, React.createElement(Label, {
    trend: trend
  }, label), tooltip ? React.createElement(Value, {
    trend: trend
  }, React.createElement(Tooltip, {
    tip: tooltip.tip,
    from: tooltip.from
  }, unit === 'percent' ? trend ? React.createElement(PercentLabel, {
    value: value
  }) : 'n/d' : null)) : React.createElement(Value, {
    trend: trend
  }, unit === 'percent' ? trend ? React.createElement(PercentLabel, {
    value: value
  }) : 'n/d' : null));
};